// Codigos de tipo de DTE del SII que maneja el sistema.
// Fuente unica para los selectores de "Tipo de documento" de las busquedas:
// agregar un tipo nuevo aca lo deja disponible en todas las vistas.
export const TIPOS_DOCUMENTO = [
  { value: 33, label: 'Factura Electrónica' },
  { value: 34, label: 'Factura Exenta Electrónica' },
  { value: 39, label: 'Boleta Electrónica' },
  { value: 41, label: 'Boleta Exenta Electrónica' },
  { value: 56, label: 'Nota de Débito Electrónica' },
  { value: 61, label: 'Nota de Crédito Electrónica' },
];

// La misma lista con el value como texto. La usan las vistas cuyo estado guarda
// el tipo como string y lo compara con === (react-select) y los <select>
// nativos, que siempre entregan string en el onChange.
export const TIPOS_DOCUMENTO_TEXTO = TIPOS_DOCUMENTO.map((tipo) => ({
  ...tipo,
  value: String(tipo.value),
}));

// Variante con "Todos" al inicio, para las busquedas que permiten no filtrar
// por tipo. El value vacio es lo que esas vistas ya enviaban al backend.
export const TIPOS_DOCUMENTO_CON_TODOS = [
  { value: '', label: 'Todos' },
  ...TIPOS_DOCUMENTO_TEXTO,
];

// Acepta el codigo como numero o como texto: las vistas no coinciden en eso.
export const getTipoDocumentoLabel = (value) =>
  TIPOS_DOCUMENTO.find((tipo) => tipo.value === Number(value))?.label ?? String(value);
